import React, { Component } from 'react';
import darkBaseTheme from 'material-ui/styles/baseThemes/darkBaseTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {
  blue500,
  blue700,
  blueGrey100,
  blueGrey500,
  darkBlack,
  grey300,
  lightBlack,
  purpleA200,
  lightGreen900,
  lime500,
  deepOrange500,
  lightGreenA400,
  lightGreen500,
  white
} from 'material-ui/styles/colors';
import Avatar from 'material-ui/Avatar';
import spacing from 'material-ui/styles/spacing'
import { fade } from 'material-ui/utils/colorManipulator'
import Drawer from 'material-ui/Drawer';
import { List, ListItem } from 'material-ui/List';
import AppBar from 'material-ui/AppBar';
import FontIcon from 'material-ui/FontIcon';
import navList from '../data/nav.json';
import { Link, Redirect, withRouter } from 'react-router-dom';
const styles = {
  iconStyles: {
    marginRight: 24,
  }
};
import Login from './login';

const muiTheme = getMuiTheme({
  spacing: {
    iconSize: 24,
    desktopGutter: 24,
    desktopGutterMore: 32,
    desktopGutterLess: 16,
    desktopGutterMini: 8,
    desktopKeylineIncrement: 64,
    desktopDropDownMenuItemHeight: 32,
    desktopDropDownMenuFontSize: 15,
    desktopLeftNavMenuItemHeight: 48,
    desktopSubheaderHeight: 48,
    desktopToolbarHeight: 56,
  },
  fontFamily: 'Roboto, sans-serif',
  palette: {
    primary1Color: blue500,
    primary2Color: blue700,
    primary3Color: lightBlack,
    accent1Color: purpleA200,
    accent2Color: blueGrey100,
    accent3Color: blueGrey500,
    textColor: darkBlack,
    alternateTextColor: white,
    canvasColor: white,
    borderColor: grey300,
    disabledColor: fade(darkBlack, 0.3),
    pickerHeaderColor: blue500,
    backCanvas: {
      viewportBackgroundColor: white,
      navDrawerBoxShadow: true
    },
  },
  avatar: {
    borderColor: white,
  },
});

class MenuBar extends Component {    
    constructor(props) {
    super(props);         
    if(!props.path)
        this.path = location.pathname;    
    var isLoggedIn = false; 
    var time = parseInt(localStorage.getItem("auth_expiry"));    
    if(!isNaN(time)){    
        if(Math.abs(time - Date.now())/36e5 > 1){          
          localStorage.clear(); 
        }
      else{
        isLoggedIn = true;
      }
      
    }
    this.state = { open: false, isLoggedIn : isLoggedIn};    
    this.setState({user : localStorage.getItem("user")});    
  }

  onMenuToggle = () => this.setState({ open: !this.state.open });

  onListItemClick = (data) => {            
    this.setState({open: false})      
    this.props.history.push(data.Prefix ? "/" + data.Prefix : "");
  }

  
  getIcon = (name) => {
    if (name == 'android')
      return <FontIcon className="material-icons" color={lightGreen500}>{name}</FontIcon>;
    else if(name == 'phone_iphone')
      return <FontIcon className="material-icons" color={blue500}>{name}</FontIcon>;
    else
    return <FontIcon className="material-icons" color={purpleA200}>{name}</FontIcon>;
  };
  
  buildMenus = (list, keyName) => {       
    if (list)
      return list.map((item) => {
        return (
        <ListItem
          key={item[keyName]}
          className="menu"
          primaryText={item[keyName]}
          initiallyOpen={item.IsOpen}
          primaryTogglesNestedList={item.Branch ? true : false}
          leftIcon={item.Branch ? this.getIcon(item.IconName) : null}  
          onTouchTap={this.onListItemClick.bind(this, item)}        
          nestedItems={this.buildMenus(item.Branch, "Name")}>          
          </ListItem>)
      })
  }
  
  render() {
    let { builds, config } = this.state;    
      let styles = {      
        button : {
          background: "#2196F3",
          padding: "10px",          
          color: "#ffffff",
          align : "center",
          fontweight : "400",
          width : "200"                
        },
        background: "#2196F3"              
      }    
    let user = localStorage.getItem("user");
    
    if(!this.state.isLoggedIn){
      return(
        //<Login data={this.path}/>
        //<Redirect to = "/"/>
        <Redirect to={{
            pathname: '/',            
            state: { path: this.path }
          }}/>
        
      );      
        
    }
    else{
      return (
        <MuiThemeProvider muiTheme={muiTheme}>
          <div className="App">          
            <AppBar title={"Welcome, " + user} onLeftIconButtonTouchTap={this.onMenuToggle} />
            <Drawer
              docked={false}
              width={275}
              open={this.state.open}
              onRequestChange={(open) => this.setState({ open })}>
              <List children={this.buildMenus(navList, "Name")}>
              </List>
            </Drawer>            
          </div>
        </MuiThemeProvider>
  
      );
    }    
  }
}

export default withRouter(MenuBar);



// WEBPACK FOOTER //
// ./src/components/app-bar.js